import React, { createContext, useContext, useState, useEffect } from 'react';

// Translations for Tekstar Bus
const translations = {
  en: {
    // Header
    'app.title': 'Tekstar Bus',
    'app.subtitle': 'Book long-distance bus tickets across Zambia',
    'nav.myTickets': 'My Tickets',
    
    // Search Form
    'search.from': 'From',
    'search.to': 'To',
    'search.departureCity': 'Departure city',
    'search.destinationCity': 'Destination city',
    'search.travelDate': 'Travel Date',
    'search.returnDate': 'Return Date',
    'search.passengers': 'Passengers',
    'search.searchBuses': 'Search Buses',
    'search.searching': 'Searching...',
    'search.roundTrip': 'Round Trip',
    'search.oneWay': 'One Way',
    'search.returnDiscount': '5% off return journey',
    
    // Results
    'results.busesFound': '{count} bus(es) found',
    'results.noBuses': 'No Buses Available',
    'results.tryDifferent': 'Try searching for a different date or route',
    'results.searchAgain': 'Search Again',
    'results.from': 'From',
    'results.perSeat': 'per seat',
    'results.seatsLeft': '{count} seats left',
    'results.select': 'Select',
    'results.soldOut': 'Sold Out',
    'results.joinWaitlist': 'Join Waitlist',
    'results.onWaitlist': 'On Waitlist',
    
    // Price Estimator
    'price.viewAllStops': 'View all stops & prices',
    'price.alightAnyStop': 'You can alight at any stop along the route',
    'price.selectDestination': 'Select your destination when choosing seats',
    'price.ofJourney': 'of journey',
    'price.final': 'Final',
    'price.standard': 'standard',
    
    // Popular Routes
    'popular.title': 'Popular Routes',
    
    // Operator CTA
    'operator.cta.title': 'Are you a Bus Operator?',
    'operator.cta.subtitle': 'Join Tekstar and reach more passengers',
    'operator.cta.button': 'Register Now',
    
    // Seat Selection
    'seats.title': 'Select Your Seats',
    'seats.passengerDetails': 'Passenger Details',
    'seats.yourSelection': 'Your Selection',
    'seats.selectSeats': 'Select {count} seat(s) to continue',
    'seats.alightingPoint': 'Alighting Point',
    'seats.extraLuggage': 'Extra Luggage (kg)',
    'seats.luggageIncluded': '{kg}kg included per passenger. K{price}/kg extra',
    'seats.subtotal': 'Subtotal',
    'seats.serviceFee': 'Service Fee',
    'seats.total': 'Total',
    'seats.continue': 'Continue',
    'seats.back': 'Back',
    'seats.proceedPayment': 'Proceed to Payment',
    'seats.intermediateStop': 'Intermediate stop - fare adjusted to {percent}% of full journey',
    
    // Seat Classes
    'class.standard': 'Standard',
    'class.business': 'Business',
    'class.vip': 'VIP',
    'class.selected': 'Selected',
    'class.booked': 'Booked',
    
    // Passenger Form
    'passenger.title': 'Passenger {num}',
    'passenger.fullName': 'Full Name',
    'passenger.asOnId': 'As on ID',
    'passenger.phone': 'Phone Number',
    'passenger.idNumber': 'ID Number (Optional)',
    'passenger.nrcPassport': 'NRC or Passport',
    
    // Checkout
    'checkout.title': 'Checkout',
    'checkout.complete': 'Complete your booking',
    'checkout.tripSummary': 'Trip Summary',
    'checkout.passengers': 'Passengers',
    'checkout.paymentMethod': 'Payment Method',
    'checkout.priceSummary': 'Price Summary',
    'checkout.confirmBooking': 'Confirm Booking',
    'checkout.processing': 'Processing...',
    'checkout.terms': 'By confirming, you agree to our terms and conditions',
    
    // Payment Methods
    'payment.cash': 'Pay at Station',
    'payment.cashDesc': 'Pay cash when boarding',
    'payment.mobileMoney': 'Mobile Money',
    'payment.mobileDesc': 'Pay with MTN/Airtel',
    'payment.card': 'Card Payment',
    'payment.cardDesc': 'Visa/Mastercard',
    
    // Confirmation
    'confirm.title': 'Booking Confirmed!',
    'confirm.subtitle': 'Your bus ticket has been booked successfully',
    'confirm.ticketCode': 'Ticket Code',
    'confirm.showQR': 'Show this QR code when boarding',
    'confirm.date': 'Date',
    'confirm.operator': 'Operator',
    'confirm.paymentStatus': 'Payment Status',
    'confirm.paid': 'Paid',
    'confirm.pending': 'Pending',
    'confirm.totalAmount': 'Total Amount',
    'confirm.viewTickets': 'View My Tickets',
    'confirm.bookAnother': 'Book Another Trip',
    
    // Sharing
    'share.title': 'Share Trip',
    'share.whatsapp': 'WhatsApp',
    'share.sms': 'SMS',
    'share.copy': 'Copy',
    'share.copied': 'Copied!',
    'share.message': 'My bus trip: {origin} → {destination} on {date} at {time}. Ticket: {code}',
    
    // Waitlist
    'waitlist.joined': 'Added to waitlist!',
    'waitlist.notify': "We'll notify you when a seat becomes available",
    'waitlist.already': 'Already on waitlist',
    
    // Errors
    'error.missingInfo': 'Missing Information',
    'error.fillFields': 'Please fill in origin, destination and travel date',
    'error.searchFailed': 'Failed to search for buses',
    'error.loginRequired': 'Login Required',
    'error.pleaseLogin': 'Please login to book bus tickets',
    
    // Language Names
    'lang.en': 'English',
    'lang.bem': 'Bemba',
    'lang.nya': 'Nyanja',
    'lang.ton': 'Tonga',
  },
  
  bem: { // Bemba
    'app.title': 'Tekstar Bus',
    'app.subtitle': 'Lemba amatiketi ya basi mu Zambia',
    'nav.myTickets': 'Amatiketi Yandi',
    
    'search.from': 'Ukufuma',
    'search.to': 'Ukuya',
    'search.departureCity': 'Musumba wakufumako',
    'search.destinationCity': 'Musumba wakufika',
    'search.travelDate': 'Ubushiku Bwakuenda',
    'search.returnDate': 'Ubushiku Bwakubwela',
    'search.passengers': 'Abantu',
    'search.searchBuses': 'Fwaya Amabasi',
    'search.searching': 'Nafwaya...',
    'search.roundTrip': 'Ukuya no Kubwela',
    'search.oneWay': 'Ukuya Fye',
    'search.returnDiscount': '5% panshi pakubwela',
    
    'results.busesFound': 'Amabasi {count} yasangwa',
    'results.noBuses': 'Tamwaba Amabasi',
    'results.tryDifferent': 'Yesha ukufwaya bushiku bumbi',
    'results.searchAgain': 'Fwaya Nakabuili',
    'results.from': 'Ukufuma',
    'results.perSeat': 'pa cipuna',
    'results.seatsLeft': 'Ifipuna {count} fishalako',
    'results.select': 'Sala',
    'results.soldOut': 'Fyapwa',
    'results.joinWaitlist': 'Ingila mu Mulenga',
    'results.onWaitlist': 'Uli mu Mulenga',
    
    'price.viewAllStops': 'Mona inshila shonse ne mitengo',
    'price.alightAnyStop': 'Kuti waikala pali ponse pa nshila',
    'price.selectDestination': 'Sala apakufika ilyo ulesala ifipuna',
    'price.ofJourney': 'ya ulwendo',
    'price.final': 'Ukushilika',
    'price.standard': 'icituntulu',
    
    'popular.title': 'Inshila Ishaishibikwa',
    
    'seats.title': 'Sala Ifipuna Fyobe',
    'seats.yourSelection': 'Ifyo Wasala',
    'seats.alightingPoint': 'Apakwikala',
    'seats.total': 'Fyonse',
    'seats.continue': 'Pita Pantanshi',
    
    'confirm.title': 'Ukulenga Kwacitika!',
    'confirm.subtitle': 'Itiketi lyobe lyalemba bwino',
    
    'share.title': 'Tumina Ulwendo',
    'share.whatsapp': 'WhatsApp',
    'share.sms': 'SMS',
    
    'lang.en': 'English',
    'lang.bem': 'Ichibemba',
    'lang.nya': 'Chinyanja',
    'lang.ton': 'Chitonga',
  },
  
  nya: { // Nyanja/Chewa
    'app.title': 'Tekstar Bus',
    'app.subtitle': 'Lembani matiketi a basi mu Zambia',
    'nav.myTickets': 'Matiketi Anga',
    
    'search.from': 'Kuchokera',
    'search.to': 'Kupita',
    'search.departureCity': 'Mzinda wochokera',
    'search.destinationCity': 'Mzinda wopita',
    'search.travelDate': 'Tsiku Loyenda',
    'search.returnDate': 'Tsiku Lobwerera',
    'search.passengers': 'Anthu',
    'search.searchBuses': 'Funani Mabasi',
    'search.searching': 'Tikufuna...',
    'search.roundTrip': 'Kupita ndi Kubwerera',
    'search.oneWay': 'Kupita Kokha',
    'search.returnDiscount': '5% pansi pobwerera',
    
    'results.busesFound': 'Mabasi {count} apezeka',
    'results.noBuses': 'Palibe Mabasi',
    'results.tryDifferent': 'Yesani tsiku lina',
    'results.searchAgain': 'Funani Kachiwiri',
    'results.from': 'Kuchokera',
    'results.perSeat': 'pa mpando',
    'results.seatsLeft': 'Mipando {count} yatsala',
    'results.select': 'Sankhani',
    'results.soldOut': 'Zathera',
    'results.joinWaitlist': 'Lowani mu Mndandanda',
    'results.onWaitlist': 'Muli mu Mndandanda',
    
    'price.viewAllStops': 'Onani malo onse ndi mitengo',
    'price.alightAnyStop': 'Mutha kutsika paliponse pa njira',
    'price.selectDestination': 'Sankhani kumene mukupita mukasankha mipando',
    'price.ofJourney': 'ya ulendo',
    'price.final': 'Komaliza',
    'price.standard': 'wamba',
    
    'popular.title': 'Njira Zodziwika',
    
    'seats.title': 'Sankhani Mipando Yanu',
    'seats.yourSelection': 'Zomwe Mwasankha',
    'seats.alightingPoint': 'Malo Otsikira',
    'seats.total': 'Zonse',
    'seats.continue': 'Pitirizani',
    
    'confirm.title': 'Kulemba Kwatheka!',
    'confirm.subtitle': 'Tiketi yanu yalemba bwino',
    
    'share.title': 'Tumizani Ulendo',
    'share.whatsapp': 'WhatsApp',
    'share.sms': 'SMS',
    
    'lang.en': 'English',
    'lang.bem': 'Ichibemba',
    'lang.nya': 'Chinyanja',
    'lang.ton': 'Chitonga',
  },
  
  ton: { // Tonga
    'app.title': 'Tekstar Bus',
    'app.subtitle': 'Lembani matiketi a basi mu Zambia',
    'nav.myTickets': 'Matiketi Aangu',
    
    'search.from': 'Kuzwa',
    'search.to': 'Kuya',
    'search.departureCity': 'Munzi wakuzwa',
    'search.destinationCity': 'Munzi wakusika',
    'search.travelDate': 'Buzuba Bwakweenda',
    'search.returnDate': 'Buzuba Bwakupiluka',
    'search.passengers': 'Bantu',
    'search.searchBuses': 'Yanduulani Mabasi',
    'search.searching': 'Ndayanduula...',
    'search.roundTrip': 'Kuya a Kupiluka',
    'search.oneWay': 'Kuya Buyo',
    'search.returnDiscount': '5% pansi aakupiluka',
    
    'results.busesFound': 'Mabasi {count} ajanika',
    'results.noBuses': 'Kunyina Mabasi',
    'results.tryDifferent': 'Amuyezye buzuba bumbi',
    'results.searchAgain': 'Yanduulani Alimwi',
    'results.from': 'Kuzwa',
    'results.perSeat': 'a cuuno',
    'results.seatsLeft': 'Zyuuno {count} zyashala',
    'results.select': 'Sala',
    'results.soldOut': 'Zyamana',
    'results.joinWaitlist': 'Njilani mu Mulongo',
    'results.onWaitlist': 'Muli mu Mulongo',
    
    'price.viewAllStops': 'Bonani busena boonse a mitengo',
    'price.alightAnyStop': 'Mulakonzya kuseluka busena boonse',
    'price.selectDestination': 'Amusale nkomukuya munosala zyuuno',
    'price.ofJourney': 'ya lwendo',
    'price.final': 'Kumana',
    'price.standard': 'ciimo',
    
    'popular.title': 'Nzila Zizibidwe',
    
    'seats.title': 'Salani Zyuuno Zyanu',
    'seats.yourSelection': 'Ncomwasala',
    'seats.alightingPoint': 'Busena Bwakuleluka',
    'seats.total': 'Zyoonse',
    'seats.continue': 'Amuzumanane',
    
    'confirm.title': 'Kulemba Kwacitika!',
    'confirm.subtitle': 'Tiketi yanu yalemba kabotu',
    
    'share.title': 'Tumina Lwendo',
    'share.whatsapp': 'WhatsApp',
    'share.sms': 'SMS',
    
    'lang.en': 'English',
    'lang.bem': 'Ichibemba',
    'lang.nya': 'Chinyanja',
    'lang.ton': 'Chitonga',
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('tekstar_language') || 'en';
  });

  useEffect(() => {
    localStorage.setItem('tekstar_language', language);
  }, [language]);

  const t = (key, params = {}) => {
    let text = translations[language]?.[key] || translations['en']?.[key] || key;
    
    // Replace parameters like {count}, {date}, etc.
    Object.keys(params).forEach(param => {
      text = text.replace(`{${param}}`, params[param]);
    });
    
    return text;
  };

  const availableLanguages = [
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'bem', name: 'Ichibemba', flag: '🇿🇲' },
    { code: 'nya', name: 'Chinyanja', flag: '🇿🇲' },
    { code: 'ton', name: 'Chitonga', flag: '🇿🇲' },
  ];

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, availableLanguages }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
